import { ReactNode } from "react";

interface BaseSectionProps {
  children: ReactNode;
  titleAside?: JSX.Element;
  title: string;
}

export const BaseSection: React.FC<BaseSectionProps> = ({
  children,
  title,
  titleAside,
}) => {
  return (
    <div className="p-6 bg-section flex-grow rounded-lg">
      <div className="flex justify-center items-center mb-2">
        <p className="text-lg font-bold text-content-dark flex-grow">{title}</p>
        {titleAside && titleAside}
      </div>
      {children}
    </div>
  );
};

// If you need the grid layout for your input container, you can use this component:
export const InputContainer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="grid grid-cols-6 gap-4">
      {children}
    </div>
  );
};
